import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnorderedList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.19995 7H18.2",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.19995 10.3333H18.2",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.19995 13.6667H18.2",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.19995 17H18.2",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.98877 7H6.98877",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.98877 10.3333H6.98877",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.98877 13.6667H6.98877",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.98877 17H6.98877",
			stroke: "black",
			strokeLinecap: "round"
		})
	]
});
export default SvgUnorderedList;
